export const PUBLIC_PRESENTATION_NOT_AVAILABLE_ERROR = 'PresentationsStandardFriendlyError.DOCUMENT_TEMPORARILY_UNAVAILABLE';